import { SET_ADJUSTMENTS } from '../types/adjustments'
import {
  fetchAdjustmentsAPI,
  updateAdjustmentAPI,
  addNewAdjustmentAPI,
  deleteAdjustmentAPI,
} from '../api/adjustments'
import { addMessageCurry, commonActionAPIHit } from '../utils/api'

export const setAdjustments = (payload) => ({
  type: SET_ADJUSTMENTS,
  payload: payload,
})

export const fetchAdjustments = (shopId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const data = { shopId }

      addMessageCurry(fetchAdjustmentsAPI(data), dispatch).then((adjustments) => {
        resolve(adjustments)
        dispatch(setAdjustments(adjustments))
      })
    })
  }
}

export const deleteAdjustment = commonActionAPIHit(deleteAdjustmentAPI)
export const addNewAdjustment = commonActionAPIHit(addNewAdjustmentAPI)
export const updateAdjustment = commonActionAPIHit(updateAdjustmentAPI)



// WEBPACK FOOTER //
// ./src/actions/adjustments.js